module.exports = __webpack_public_path__ + "img/minting-shape3.e6fe3541.png";